import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSnapshot,
  fetchVouches,
  fetchTopTalent,
  fetchIntroRequested,
  fetchIntroMade,
  fetchIntroPending,
  fetchIntroQueue,
} from './actions';

const initialState = {
  snapshot: {
    isLoading: true,
    data: [],
  },
  timeRange: {
    to: null,
    from: null,
    label: 'Last 7 days',
    id: '7d',
  },
  vouch: {
    isLoading: true,
    data: [],
  },
  topTalent: {
    isLoading: true,
    data: [],
  },
  introRequested: {
    isLoading: true,
    data: [],
  },
  introMade: {
    isLoading: true,
    data: [],
  },
  introPending: {
    isLoading: true,
    data: [],
  },
  introQueue: {
    isLoading: true,
    data: [],
  },
};

const { reducer, actions } = createSlice({
  name: 'dashboardCircles',
  initialState,

  reducers: {
    applyTimeRange: (state, { payload }) => {
      const { to, from, label, id } = payload;
      state.timeRange.to = to;
      state.timeRange.from = from;
      state.timeRange.label = label;
      state.timeRange.id = id;
    },
  },

  extraReducers: {
    [fetchSnapshot.pending]: (state) => {
      state.snapshot.isLoading = true;
    },

    [fetchSnapshot.fulfilled]: (state, { payload }) => {
      state.snapshot.data = payload?.data || {};
      state.snapshot.isLoading = false;
    },

    [fetchVouches.pending]: (state) => {
      state.vouch.isLoading = true;
    },

    [fetchVouches.fulfilled]: (state, { payload }) => {
      state.vouch.data = payload || {};
      state.vouch.isLoading = false;
    },

    [fetchTopTalent.pending]: (state) => {
      state.topTalent.isLoading = true;
    },

    [fetchTopTalent.fulfilled]: (state, { payload }) => {
      state.topTalent.data = payload || {};
      state.topTalent.isLoading = false;
    },

    [fetchIntroRequested.pending]: (state) => {
      state.introRequested.isLoading = true;
    },

    [fetchIntroRequested.fulfilled]: (state, { payload }) => {
      state.introRequested.data = payload || {};
      state.introRequested.isLoading = false;
    },

    [fetchIntroMade.pending]: (state) => {
      state.introMade.isLoading = true;
    },

    [fetchIntroMade.fulfilled]: (state, { payload }) => {
      state.introMade.data = payload || {};
      state.introMade.isLoading = false;
    },

    [fetchIntroPending.pending]: (state) => {
      state.introPending.isLoading = true;
    },

    [fetchIntroPending.fulfilled]: (state, { payload }) => {
      state.introPending.data = payload || {};
      state.introPending.isLoading = false;
    },

    [fetchIntroQueue.pending]: (state) => {
      state.introQueue.isLoading = true;
    },

    [fetchIntroQueue.fulfilled]: (state, { payload }) => {
      state.introQueue.data = payload || {};
      state.introQueue.isLoading = false;
    },
  },
});

export const { applyTimeRange } = actions;

export default reducer;
